import { render, staticRenderFns } from "./ProductionBatchView.vue?vue&type=template&id=cb3ec54e&scoped=true&"
import script from "./ProductionBatchView.vue?vue&type=script&lang=js&"
export * from "./ProductionBatchView.vue?vue&type=script&lang=js&"
import style0 from "./ProductionBatchView.vue?vue&type=style&index=0&id=cb3ec54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3ec54e",
  null
  
)

export default component.exports